import { merge as xMerge } from 'lodash';

export const PLAN_VIEW_RESIZE_EVENT_TYPE = "plan_view_resize";
export const PLAN_VIEW_PAINT_EVENT_TYPE = "plan_paint";
export const PLAN_VIEW_MOUSEMOVE_EVENT_TYPE = "plan_mousemove";
export const PLAN_VIEW_CLICK_EVENT_TYPE = "plan_click";
export const PLAN_VIEW_DOCUMENT_RENDERED_EVENT_TYPE = "plan_rendered";

export const PLAN_VIEW_REPAINT_EVENT_TYPE = "plan_repaint";
export const PLAN_VIEW_REGEN_EVENT_TYPE = "plan_regen";
export const PLAN_VIEW_ZOOM_EXTENTS_EVENT_TYPE = "plan_zoom_extents";


export class PlanViewEvent extends Event {
    constructor(type = "plan_event", initializer = {}) {
        super(type, {
            ...initializer,
            cancelable: true
        });
    }
}


export class PlanViewResizeEvent extends PlanViewEvent {
    constructor(width, height) {
        super(PLAN_VIEW_RESIZE_EVENT_TYPE);
        this.width = width;
        this.height = height;
    }
}


export class PlanViewPaintEvent extends PlanViewEvent {
    constructor(info) {
        super(PLAN_VIEW_PAINT_EVENT_TYPE);
        xMerge(this, info);
    }
}


export class PlanViewRepaintEvent extends PlanViewEvent {
    constructor(info) {
        super(PLAN_VIEW_REPAINT_EVENT_TYPE);
        xMerge(this, info);
    }
}


export class PlanViewRegenEvent extends PlanViewEvent {
    constructor(info) {
        super(PLAN_VIEW_REGEN_EVENT_TYPE);
        xMerge(this, info);
    }
}


export class PlanViewZoomExtentsEvent extends PlanViewEvent {
    constructor(info) {
        super(PLAN_VIEW_ZOOM_EXTENTS_EVENT_TYPE);
        xMerge(this, info);
    }
}


export class PlanViewMouseMoveEvent extends PlanViewEvent {
    constructor(info) {
        super(PLAN_VIEW_MOUSEMOVE_EVENT_TYPE);
        xMerge(this, info);
    }
}


export class PlanViewClickEvent extends PlanViewEvent {
    constructor(info) {
        super(PLAN_VIEW_CLICK_EVENT_TYPE);
        xMerge(this, info);
    }
}


export class PlanViewDocumentRenderedEvent extends PlanViewEvent {
    constructor(info) {
        super(PLAN_VIEW_DOCUMENT_RENDERED_EVENT_TYPE);
        xMerge(this, info);
    }
}
